import { put, call, select, delay, race } from 'redux-saga/effects'
import { createModal } from 'redux-saga-modal'
import {
  SHOW_INFO_DIALOG,
} from './actionTypes'
import * as services from './services'
import * as actions from './actions'

export default {

  *[SHOW_INFO_DIALOG]({ payload }) {
    const { params } = payload
    const modal = createModal('BANNER_DIALOG')
    yield modal.show(params)
    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })
    if (submit) {
      yield modal.hide()
    } else {
      yield modal.destroy()
    }
  },

}
